import eventBus from '@/services/eventBus'
import { IEnum, IMDMUnit, IMDMUnitInstance, IPassportGroup, IPassportSchema } from '@/pages/MDM/mdm.types.ts'

const enumCreated = (item: IEnum) => {
  eventBus.pub('mdm.enums.created', item)
}

const enumUpdated = (item: IEnum) => {
  eventBus.pub('mdm.enums.updated', item)
}

const enumDeleted = (id: IEnum['id']) => {
  eventBus.pub('mdm.enums.deleted', id)
}

const unitCreated = (item: IMDMUnit) => {
  eventBus.pub('mdm.units.created', item)
}

const unitUpdated = (item: IMDMUnit) => {
  eventBus.pub('mdm.units.updated', item)
}

const unitDeleted = (id: IMDMUnit['id']) => {
  eventBus.pub('mdm.units.deleted', id)
}

const unitInstanceCreated = (item: IMDMUnitInstance) => {
  eventBus.pub('mdm.units.instances.created', item)
}

const unitInstanceUpdated = (item: IMDMUnitInstance) => {
  eventBus.pub('mdm.units.instances.updated', item)
}

const unitInstanceDeleted = (id: IMDMUnitInstance['id']) => {
  eventBus.pub('mdm.units.instances.deleted', id)
}

const passportSchemaCreated = (item: IPassportSchema) => {
  eventBus.pub('mdm.passports.created', item)
}

const passportSchemaUpdated = (item: IPassportSchema) => {
  eventBus.pub('mdm.passports.updated', item)
}

const passportSchemaDeleted = (id: IPassportSchema['id']) => {
  eventBus.pub('mdm.passports.deleted', id)
}

const passportSchemaGroupCreated = (item: IPassportGroup) => {
  eventBus.pub('mdm.passports.groups.created', item)
}

const passportSchemaGroupUpdated = (item: IPassportGroup) => {
  eventBus.pub('mdm.passports.groups.updated', item)
}

const passportSchemaGroupDeleted = (id: IPassportGroup['id']) => {
  eventBus.pub('mdm.passports.groups.deleted', id)
}

const mdmEvents = {
  enumCreated,
  enumUpdated,
  enumDeleted,
  unitCreated,
  unitUpdated,
  unitDeleted,
  unitInstanceCreated,
  unitInstanceUpdated,
  unitInstanceDeleted,
  passportSchemaCreated,
  passportSchemaUpdated,
  passportSchemaDeleted,
  passportSchemaGroupCreated,
  passportSchemaGroupUpdated,
  passportSchemaGroupDeleted,
}
export default mdmEvents
